import React from "react";
import "./styles.css";

// ✅ Components (default exports, no curly braces)
import Header from "./components/Header.js"
import Section from "./components/Section.js";


// ✅ Data (arrays/objects) — make sure these are from content/* not components/*
import experience from "./content/experience";
import misc from "./content/misc";
import education from "./content/education"


import research from "./content/research";
import projects from "./content/projects";
import talks from "./content/talks";
import publications from "./content/publications";
import { MiscList, ExperienceList, EducationList, ResearchBlock, ProjectsBlock, TalksList, PublicationsList } from "./components/RenderList.js";

export default function App() {
  return (

    <main>
      <Header />

      <section className="container" style={{ padding: "2rem 0" }}>
        <div className="profile-header">
          <img src="/pic.PNG" alt="sheryl" className="profile-pic" />
          <div className="profile-info">
          <h1>Sheryl Deakin</h1>
            <a href="https://www.khoury.northeastern.edu/">Khoury College of Computer Science, Northeastern University</a>
            <p>Master of Science in Artificial Intelligence</p>
            <p>Research Assistant, <a href="https://civicai.khoury.northeastern.edu/">Civic A.I. Lab</a></p>
            <p>Email: deakin.s@northeastern.edu</p>

          </div>
        </div>
      </section>

      <Section id="interests" title="About Me">
        <p>I build human-centered AI systems for mental health, where technical decisions carry real human stakes.
          My work centers on a core belief: in high-stakes domains, AI should serve as cognitive scaffolding that supports clinicians and empowers patients, not as a decision-making authority.
          I am currently a Research Assistant in the <a href="https://civicai.khoury.northeastern.edu/">Civic A.I. Lab</a> at Northeastern, working on my master's thesis
          and building <a href="https://mymindstorm.ai">MindStorm</a>, a clinician-in-the-loop decision support system for psychiatric diagnosis.</p>
        <p>A core question driving my work is where LLMs should and should not operate in high-stakes settings, and how to partition their use in ways that are both safe and ethical.</p>
        <p>Always exploring ways to connect personal growth with technical systems, from building dashboards to track daily life, to designing AI that helps people understand themselves better.</p>
      </Section>

      <Section id="research" title={research.title}>
        <ResearchBlock data={research} />
      </Section>

      <Section id="publications" title="Publications">
        <PublicationsList data={publications} />
      </Section>

      <Section id="talks" title="Talks & Presentations">
        <TalksList data={talks} />
      </Section>

      <Section id="experience" title={experience.title}>
        <ExperienceList data={experience} />
      </Section>

      <Section id="education" title={education.title}>
        <EducationList data={education} />
      </Section>

      <Section id="projects" title={projects.title}>
        <ProjectsBlock data={projects} />
      </Section>

      <Section id="misc" title={misc.title}>
        <MiscList data={misc} />
      </Section>

    </main>
  );
}
